// extracted by mini-css-extract-plugin
export var socialSharing = "socialSharing-3pu";
export var copied = "copied-1Eo";
export var label = "label-kzM";